module.exports = __webpack_public_path__ + "img/315deg.a97c4113.svg";